// Entry point to our vue aplication


//bring in bulma
import './../node_modules/bulma/css/bulma.css';

//bring in vue
import Vue from 'vue'

//bring in app component
import App from './App.vue'

//bring in nav component

//bring in router
import router from './router'


Vue.config.productionTip = false


// new Vue({
//   el: '#app',
//   router,
//   render: h => h(App)
//    .$mount('#app')
// })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
// (response => (this.info = response.data.bpi))